<template>
    <div>
        <div class="section-subtitle">
            <i class="icon icon-grid"></i
            ><span
                >{{ $t("app.links.budget_requests")
                }}<budget-forms-list :curFormSelect="'/form01-123'"
            /></span>
            <forms-download-reprt
                :progress="progress"
                :isReportUploading="isReportUploading"
                :form="form"
                :guListLen="guListLen"
                :header="header"
                :isParentGuExist="isParentGuExist"
                :isHeadGu="isHeadGu"
                :hasDeltaRep="true"
                @checkSignatories="checkSignatories"
                @downloadRep="downloadRep"
                @downloadDeltaRep="downloadDeltaRep"
                @downloadBatchReports="downloadBatchReports"
                @downloadBatchReportsPaid="downloadBatchReportsPaid"
            ></forms-download-reprt>
        </div>
        <div class="filter-container">
            <div class="left-content">
                <p v-if="!categoryMode" class="title">
                    {{ getCommonText("decoding") }}. {{ caterogyName }}
                </p>
            </div>
            <div class="right-content">
                <c-budget-forms-data-transfer
                    v-if="
                        categoryMode &&
                        !isGkkpMode &&
                        !(progress < 100) &&
                        variantAttribute
                    "
                    :header="header"
                    :lng="lng"
                    :getDataTransferText="getDataTransferText"
                    :getErrText="getErrText"
                    :makeToast="makeToast"
                    @reloadTable="loadCategoryData"
                />
                <div class="filter-actions filter-actions-flex">
                    <template v-if="categoryMode">
                        <c-budget-forms-copy-data
                            v-if="
                                !(progress < 100) &&
                                variantAttribute &&
                                header.year < header.cur_year + 2
                            "
                            :budgetForm="budgetForm"
                            :header="header"
                            :isLoad="isLoad"
                            @keyPress="keyPress"
                        />
                        <b-button
                            variant="primary"
                            @click="addItem"
                            v-if="variantAttribute"
                            :disabled="isLoad"
                            ><i class="icon icon-plus-circle"></i>
                            {{ getCommonText("add") }}</b-button
                        >
                    </template>
                    <template v-else>
                        <b-button variant="light" @click="resetModal">
                            <i class="icon icon-keyboard icon-rotate-180"></i>
                            {{ getCommonText("back_to_list") }}
                        </b-button>
                        <b-button
                            :style="{ minWidth: '110px' }"
                            v-if="variantAttribute"
                            variant="primary"
                            @click="$refs.formTemplate.addItem()"
                        >
                            <i class="icon icon-plus-circle"></i
                            >{{ getCommonText("add") }}
                        </b-button>
                        <b-button
                            :style="{ minWidth: '110px' }"
                            :disabled="!dataChanged || isLoad"
                            variant="success"
                            @click="prepareForSaveDecodes"
                        >
                            {{ getCommonText("save") }}
                        </b-button>
                    </template>
                </div>
            </div>
        </div>

        <div v-show="categoryMode" class="table-container">
            <b-overlay :show="isLoad" rounded="sm">
                <b-overlay :show="mainTableOverlay" rounded="sm">
                <b-table
                    :fields="tableFields"
                    :items="budgetFormWithTotalAmount"
                    responsive="true"
                    bordered
                    head-variant="light"
                    sticky-header="true"
                    no-border-collapse
                >
                    <template #top-row="data">
                        <td></td>
                        <td class="td-numbering"></td>
                        <td class="td-numbering text-center table-success">
                            1
                        </td>
                        <td class="td-numbering text-center table-danger">2</td>
                        <td class="td-numbering text-center table-info">3</td>
                        <td class="td-numbering text-center table-primary">
                            4
                        </td>
                        <td class="td-numbering text-center table-warning">
                            5
                        </td>
                        <td class="td-numbering text-center table-success">
                            6
                        </td>
                        <td class="td-numbering text-center table-danger">7</td>
                        <td class="td-numbering text-center table-info">8</td>
                        <td class="td-numbering text-center table-primary">
                            9
                        </td>
                        <td class="td-numbering text-center table-warning">
                            10
                        </td>
                        <td class="td-numbering"></td>
                    </template>
                    <template #head(selection)>
                        <div class="text-center">
                            <b-form-checkbox
                                v-model="selectAll"
                                @change="
                                    (e) =>
                                        setIsAllDelete(
                                            e,
                                            budgetFormWithTotalAmount
                                        )
                                "
                                :value="true"
                                :unchecked-value="false"
                            />
                        </div>
                    </template>
                    <template #head(more)>
                        <div class="text-center">
                            <i
                                :title="getCommonText('del_selected')"
                                class="icon icon-close table-all-remove"
                                @click="
                                    deleteItem(
                                        `${
                                            selectAll
                                                ? getCommonText('all_cats')
                                                : getCommonText('selected_cats')
                                        }`
                                    )
                                "
                            />
                        </div>
                    </template>
                    <template #cell(selection)="data">
                        <div class="text-center">
                            <b-form-checkbox
                                v-model="data.item.itemToDelete"
                                @input="
                                    (e) => {
                                        if (!e) selectAll = false;
                                    }
                                "
                                :value="true"
                                :unchecked-value="false"
                            />
                        </div>
                    </template>
                    <template #cell(action)="data">
                        <button
                            v-if="!data.item.isTotalAmountRow"
                            class="table-plus"
                            v-b-modal.goods-modal
                            @click="setCurrCatName(data.item)"
                            :disabled="
                                data.item.checkForDuplicates ||
                                !data.item.product_group
                            "
                        >
                            <i class="icon icon-plus-circle" />
                        </button>
                    </template>
                    <template #cell(product_group)="data">
                        <div class="column-width-400 form01-158_product-group">
                            <multiselect
                                v-if="
                                    variantAttribute &&
                                    !data.item.isTotalAmountRow
                                "
                                v-model="data.item.curr_product_group"
                                :title="
                                    'curr_product_group' in data.item
                                        ? data.item.curr_product_group[
                                              `name_${lng}`
                                          ]
                                        : null
                                "
                                :label="`name_${lng}`"
                                :placeholder="getFormText('select_name')"
                                :options="dictProductGroups"
                                :searchable="true"
                                :allow-empty="false"
                                :show-labels="false"
                                @input="onNameCodeChanged(data.item)"
                            >
                            </multiselect>
                            <div v-else>
                                {{
                                    data.item.curr_product_group[`name_${lng}`]
                                }}
                            </div>
                        </div>
                    </template>

                    <template #cell(inf_sys)="data">
                        <div
                            class="column-width-100 bp-category-name"
                            v-if="!data.item.isTotalAmountRow"
                        >
                            <div>{{ data.item["inf_sys_" + lng] }}</div>
                            <i
                                v-if="
                                    variantAttribute && data.item.product_group
                                "
                                class="icon icon-pencil-edit thin-blue ml-3 pointer icon-18"
                                @click="
                                    showEditModal(data.item, 'setInfSysModal')
                                "
                            ></i>
                        </div>
                        <div v-else class="text-center">x</div>
                    </template>
                    <template #cell(name_prod)="data">
                        <div
                            class="column-width-100 bp-category-name"
                            v-if="!data.item.isTotalAmountRow"
                        >
                            <div>{{ data.item["name_prod_" + lng] }}</div>
                            <i
                                v-if="
                                    variantAttribute && data.item.product_group
                                "
                                class="icon icon-pencil-edit thin-blue ml-3 pointer icon-18"
                                @click="
                                    showEditModal(data.item, 'setNameProdModal')
                                "
                            ></i>
                        </div>
                        <div v-else class="text-center">x</div>
                    </template>

                    <template #cell(actual_expens)="data">
                        <b-form-input
                            v-if="
                                variantAttribute && data.item.isTotalAmountRow
                            "
                            class="text-right"
                            :value="data.item.actual_expens"
                            @change="(v) => (data.item.actual_expens = v)"
                            @keyup.enter.exact="keyup13"
                            @keypress="
                                keyPress($event, '^\\d*\\.?\\-?\\d{0,9}$')
                            "
                            @blur="
                                inputFixed(
                                    data.item,
                                    'actual_expens',
                                    data.item.actual_expens,
                                    2
                                )
                            "
                        >
                        </b-form-input>

                        <div
                            v-else-if="data.item.isTotalAmountRow"
                            class="text-right"
                        >
                            {{ $n(data.item.actual_expens) }}
                        </div>
                        <div v-else class="text-center">x</div>
                    </template>

                    <template #cell(revis_plan)="data">
                        <b-form-input
                            v-if="
                                variantAttribute && data.item.isTotalAmountRow
                            "
                            class="text-right"
                            :value="data.item.revis_plan"
                            @change="(v) => (data.item.revis_plan = v)"
                            @keyup.enter.exact="keyup13"
                            @keypress="
                                keyPress($event, '^\\d*\\.?\\-?\\d{0,9}$')
                            "
                            @blur="
                                inputFixed(
                                    data.item,
                                    'revis_plan',
                                    data.item.revis_plan,
                                    2
                                )
                            "
                        >
                        </b-form-input>

                        <div
                            v-else-if="data.item.isTotalAmountRow"
                            class="text-right"
                        >
                            {{ $n(data.item.revis_plan) }}
                        </div>
                        <div v-else class="text-center">x</div>
                    </template>

                    <template #cell(amount)="data">
                        <div
                            v-if="data.item.isTotalAmountRow"
                            class="text-center"
                        >
                            x
                        </div>
                        <div v-else class="text-right">
                            {{ $n(data.item.amount) }}
                        </div>
                    </template>

                    <template #cell(one_item_cost)="data">
                        <div
                            v-if="data.item.isTotalAmountRow"
                            class="text-center"
                        >
                            x
                        </div>
                        <div v-else class="text-right">
                            {{ $n(data.item.one_item_cost) }}
                        </div>
                    </template>

                    <template #cell(total)="data">
                        <div
                            v-if="data.item.isTotalAmountRow"
                            class="text-center"
                        >
                            x
                        </div>
                        <div v-else class="text-right">
                            {{ $n(data.item.total) }}
                        </div>
                    </template>

                    <template #cell(files)="data">
                        <span
                            class="blue pointer underline"
                            v-if="!data.item.isTotalAmountRow"
                            @click="
                                onAllFilesClick({
                                    ...data.item,
                                    name_ru:
                                        data.item.curr_product_group[
                                            `name_${lng}`
                                        ],
                                })
                            "
                            >({{
                                data.item.files ? data.item.files.length : 0
                            }})</span
                        >
                    </template>
                    <template #cell(more)="data">
                        <i
                            class="icon icon-clear table-remove"
                            v-if="variantAttribute"
                            :disabled="deletingCat"
                            @click="
                                deleteItem(getCommonText('curr_cat'), data.item)
                            "
                        ></i>
                    </template>

                    <template #bottom-row="data">
                        <td class="text-right" colspan="4">
                            {{ getCommonText("total") }}
                        </td>
                        <td class="text-center">x</td>
                        <td class="text-center">x</td>
                        <td class="text-right">
                            {{ $n(Math.ceil(totalAmountBySpecificity.actual_expens)) }}
                        </td>
                        <td class="text-right">
                            {{ $n(Math.ceil(totalAmountBySpecificity.revis_plan)) }}
                        </td>
                        <td class="text-right">{{ $n(totalAmount) }}</td>
                        <td class="text-right">{{ $n(totalOneItemCost) }}</td>
                        <td class="text-right">{{ $n(total) }}</td>
                        <td colspan="2"></td>
                    </template>
                </b-table>
                </b-overlay>
                <div
                    class="table-add"
                    v-if="variantAttribute"
                    :disabled="isLoad"
                >
                    <span @click="addItem"
                        ><i class="icon icon-plus-circle"></i>
                        {{ getCommonText("add") }}</span
                    >
                </div>
            </b-overlay>
        </div>
        <template v-if="!categoryMode">
            <b-overlay :show="templateTableOverlay" rounded="sm">
                <form-template11
                    ref="formTemplate"
                    :goodsData="goodsData"
                    :ensTruDict="ensTruDict"
                    :variantAttribute="variantAttribute"
                    :currCategory="currCategory"
                    :lng="lng"
                    :lang="lang"
                    :ifAllFieldsFilled="ifAllFieldsFilled"
                    @deleteRows="deleteRows"
                    :ensTruNamePrt="ensTruNamePrt"
                    :ensTruName="ensTruName"
                    :descIsLoading="descIsLoading"
                    :parNameLoading="parNameLoading"
                    :allFiles="allFiles"
                    @searchName="searchName"
                    @setIsAllDelete="setIsAllDelete"
                    @doublesValidationDecodes="doublesValidationDecodes"
                    @setDataChanged="setDataChanged"
                    :triggDownloadFile="triggDownloadFile"
                    :triggDownloadAllFiles="triggDownloadAllFiles"
                    :showFileUploadModal="showFileUploadModal"
                    :getEnstruByName="getEnstruByName"
                    :loadCurUnits="loadCurUnits"
                    :goodsAreSaving="goodsAreSaving"
                    :isDoubleDecodeExist="isDoubleDecodeExist"
                    :safeDecimal="safeDecimal"
                >
                </form-template11>

                <div class="table-add" v-if="variantAttribute">
                    <span @click="$refs.formTemplate.addItem()"
                        ><i class="icon icon-plus-circle"></i>
                        {{ getCommonText("add") }}</span
                    >
                </div>
            </b-overlay>
        </template>
        <files-updown
            ref="filesUpdown"
            v-show="categoryMode"
            :header="header"
            :variant-attribute="variantAttribute"
            :variant-name="variantName ? variantName['pure_name_' + lng] : ''"
            :load="isLoad"
            :showDeleteLinks="variantAttribute"
            :showDeleteAll="true"
            @getFiles="getFiles"
            @fillFilesList="fillFilesList"
            @restetFilesList="restetFilesList"
            @delelteAttachedFile="delelteAttachedFile"
            @onFilePreview="onFilePreview"
        ></files-updown>
        <modal-all-files-management
            ref="modalAllFilesManagement"
            :allFiles="allFiles"
            @triggDownloadFile="triggDownloadFile"
            @triggDownloadAllFiles="triggDownloadAllFiles"
        >
        </modal-all-files-management>
        <c-set-b-f-category-name
            ref="setInfSysModal"
            :budgetForm="budgetForm"
            :lng="lng"
            :getCommonText="getCommonText"
            :categoryFieldNames="{ ru: 'inf_sys_ru', kk: 'inf_sys_kk' }"
            :maxNameLengthSymbls="255"
            :title="this.getFormText('inf_sys')"
            :textareaTitleRu="this.getFormText('inf_sys_textarea_title_ru')"
            :textareaTitleKk="this.getFormText('inf_sys_textarea_title_kk')"
            :placeHolder="this.getFormText('inf_sys_placeholder')"
            :canBeEmpty="true"
            :isDoublesCheckNeeded="false"
            @saveItem="saveItem"
        />
        <c-set-b-f-category-name
            ref="setNameProdModal"
            :budgetForm="budgetForm"
            :lng="lng"
            :getCommonText="getCommonText"
            :categoryFieldNames="{ ru: 'name_prod_ru', kk: 'name_prod_kk' }"
            :maxNameLengthSymbls="255"
            :title="this.getFormText('name_prod')"
            :textareaTitleRu="this.getFormText('name_prod_textarea_title_ru')"
            :textareaTitleKk="this.getFormText('name_prod_textarea_title_kk')"
            :placeHolder="this.getFormText('name_prod_placeholder')"
            :canBeEmpty="true"
            :isDoublesCheckNeeded="false"
            @saveItem="saveItem"
        />
    </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import FilesUpdown from "@/modules/budget-request/FilesUpdown";
import BudgetFormsList from "@/modules/budget-request/components/budget-forms-list.vue";
import FormsHandlerMixin from "@/modules/budget-request/mixins/forms-handler-mixin";
import FormTemplate11 from "@/modules/budget-request/components/budget-forms-template11.vue";
import ModalAllFilesManagement from "@/modules/budget-request/components/modal-all-files-management.vue";
import CBudgetFormsCopyData from "@/modules/budget-request/components/budget-forms-copy-data.vue";
import FormsDownloadReprt from "@/modules/budget-request/components/forms-download-reprt.vue";
import CBudgetFormsDataTransfer from "@/modules/budget-request/components/budget-forms-data-transfer.vue";
import CSetBFCategoryName from "@/modules/budget-request/components/c-set-bf-category-name.vue";

export default {
    name: "Form01_158",
    components: {
        FilesUpdown,
        BudgetFormsList,
        FormsDownloadReprt,
        FormTemplate11,
        ModalAllFilesManagement,
        CBudgetFormsCopyData,
        CSetBFCategoryName,
        CBudgetFormsDataTransfer,
    },
    mixins: [FormsHandlerMixin],
    data() {
        return {
            form: {
                code: "01-158",
                name_kk:
                    "Расчет расходов на оплату работ и услуг в сфере информатизации.",
                name_ru:
                    "Ақпараттандыру саласындағы жұмыстар мен көрсетілетін қызметтерге ақы төлеуге арналған шығыстарды есептеу.",
            },
            dataTypeFilter: null,
            variantAttribute: null,
            variantName: null,
            budgetForm: [],
            header: null,
            files: null,
            isLoad: false,
            includedTypes: [2, 3],
            dictProductGroups: [],
            totalAmountBySpecificity: {},
        };
    },
    created() {
        this.$emit("setForm", this.form);
        this.createTotalAmountBySpecificity();
    },
    mounted() {
        this.progress = 15;
    },
    watch: {
        categoryMode() {
            this.$emit("setCategoryMode", this.categoryMode);
        },
        progress() {
            this.$emit("setProgress", this.progress);
        },
        goodsData: {
            handler() {
                const isHasDataToSave = this.goodsData.some(
                    (gd) => gd.rowToSave
                );
                if (isHasDataToSave) this.setDataChanged(true);
                else this.setDataChanged(false);
            },
            deep: true,
        },
    },
    methods: {
        itemUpdate(item) {
            this.$set(item, "order_number", this.budgetForm.length + 1);
            this.$set(item, "product_group", null);
            // this.$set(item, "curr_product_group", null);
            this.$set(item, "inf_sys_ru", "");
            this.$set(item, "inf_sys_kk", "");
            this.$set(item, "name_prod_ru", "");
            this.$set(item, "name_prod_kk", "");
            this.$set(item, "actual_expens", null);
            this.$set(item, "revis_plan", null);
            this.$set(item, "amount", 0);
            this.$set(item, "one_item_cost", 0);
            this.$set(item, "total", 0);
            this.$set(item, "newCat", true);
            this.$set(item, "category_id", this.uuidv4());
            this.$set(item, "checkForDuplicates", false);
            this.$set(item, "isDataValid", false);
            this.$set(item, "itemToDelete", false);
        },

        createTotalAmountBySpecificity() {
            this.totalAmountBySpecificity = {
                id: -1,
                order_number: null,
                product_group: null,
                curr_product_group: {
                    code: null,
                    name_ru: "Общая сумма по специфике",
                    name_kk: "Ерекшелік бойынша жалпы сомасы",
                },
                inf_sys_ru: null,
                inf_sys_kk: null,
                name_prod_ru: null,
                name_prod_kk: null,
                actual_expens: 0,
                revis_plan: 0,
                amount: null,
                one_item_cost: null,
                total: null,
                newCat: true,
                category_id: this.uuidv4(),
                itemToDelete: false,
                isDataValid: true,
                isTotalAmountRow: true,
            };
        },

        inputFixed(item, field, value, digit) {
            // nextTick добавлен тк не без него не работает реактивность при событии keyPress.enter если предыдущее значение = 0
            this.$nextTick(() => {
                let newVal = this.safeDecimal(value)
                    .toDecimalPlaces(digit)
                    .toNumber();
                if (newVal !== item[field]) {
                    if (newVal < 0) newVal = newVal * -1;
                    this.$set(item, field, newVal);
                    this.save(item, true);
                }
            });
        }, // форматирует введенное значение до digit цифр после запятой

        onNameCodeChanged(item) {
            this.$set(item, "product_group", item.curr_product_group.code);
            this.disableSelectedCodes();
            this.checkForDuplicates("product_group");
            if (!this.areDoublesFound) {
                this.save(item, true);
            }
        },

        disableSelectedCodes() {
            this.dictProductGroups.forEach((item) => {
                const isProductGroupSelected = this.budgetForm.some(
                    (bf) => bf.product_group === item.code
                );
                this.$set(item, "$isDisabled", isProductGroupSelected);
            });
        },

        saveItem(item) {
            this.save(item, true);
        },

        async save(item, isSaveCat = false) {
            this.isLoad = true;
            this.setIsCopyRowsBtnVisible(false);
            const data = {
                isSaveCat: isSaveCat,
                values: item,
                header: this.header,
            };
            try {
                const response = await fetch("/api-py/save-brform01-158/", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json;charset=utf-8",
                    },
                    body: JSON.stringify(data),
                });
                if (response.ok) {
                    const result = await response.json();

                    if ("result" in result && result["result"] == "success") {
                        if (isSaveCat) {
                            if ("new_id" in result) {
                                this.$set(item, "id", result["new_id"]);
                            }
                        } else {
                            if ("new_ids" in result) {
                                result["new_ids"].forEach((ids) => {
                                    const savedRow = this.goodsData.find(
                                        (gd) => gd.id === ids["old_id"]
                                    );
                                    if (savedRow)
                                        this.$set(
                                            savedRow,
                                            "id",
                                            ids["new_id"]
                                        );
                                });
                            }
                            this.resetDecodes();

                            this.makeToast(
                                "success",
                                this.getErrText("msg"),
                                this.getErrText("saved")
                            );
                        }
                        if (!isSaveCat) this.loadCategoryData();
                    } else {
                        this.makeToast(
                            "danger",
                            this.getErrText("not_saved"),
                            "Error"
                        );
                    }
                } else {
                    this.makeToast(
                        "danger",
                        this.getErrText("not_saved"),
                        "Error:" + response.status
                    );
                }
            } catch (e) {
                this.makeToast(
                    "danger",
                    this.getErrText("warning"),
                    e.toString()
                );
            } finally {
            }
            this.selectAll = false;

            this.isLoad = false;
        },

        resetDecodes() {
            this.goodsData.forEach((item) => {
                this.$set(item, "isNew", false);
                this.$set(item, "rowToSave", false);
                this.$set(item, "itemToDelete", false);
                this.$set(item, "isHasDouble", false);
                this.$set(item, "isDataValid", true);
            });
        },

        showEditModal(row, modalRef) {
            if (!row.product_group) return;

            const modal = this.$refs[modalRef];
            if (modal) modal.showModal(row);
        },

        deleteItem(msg, row = false) {
            if (
                !this.variantAttribute ||
                this.isLoad ||
                (!row &&
                    !this.budgetFormWithTotalAmount.some(
                        (itm) => itm.itemToDelete
                    ))
            )
                return;

            if (row) this.currCategory = row.category_id;

            this.$bvModal
                .msgBoxConfirm(
                    this.getCommonText("del_with_decodes", { msg: msg }),
                    {
                        title: this.getCommonText("confirm"),
                        size: "lg",
                        buttonSize: "sm",
                        okVariant: "danger",
                        okTitle: this.getCommonText("yes"),
                        cancelTitle: this.getCommonText("cancel"),
                        footerClass: "p-2",
                        hideHeaderClose: false,
                        centered: true,
                    }
                )
                .then(async (value) => {
                    if (value) {
                        this.deletingCat = true;
                        if (row) {
                            if (row.id >= 0) {
                                this.deleteRows([row], "category");
                                if (row.isTotalAmountRow) {
                                    this.resetTotalAmountBySpecificity();
                                }
                            } else {
                                if (row.isTotalAmountRow) {
                                    this.resetTotalAmountBySpecificity();
                                } else {
                                    const idxToDel = this.budgetForm.findIndex(
                                        (itm) => itm === row
                                    );
                                    this.budgetForm.splice(idxToDel, 1);
                                }
                            }
                        } else {
                            const existingRowsToDel =
                                this.budgetFormWithTotalAmount.filter(
                                    (item) => item.id >= 0 && item.itemToDelete
                                );
                            this.budgetForm = this.budgetForm.filter(
                                (item) => !item.itemToDelete
                            );
                            if (this.totalAmountBySpecificity.itemToDelete) {
                                this.createTotalAmountBySpecificity();
                            }
                            if (!existingRowsToDel.length) {
                                this.selectAll = false;
                            } else {
                                await this.deleteRows(
                                    existingRowsToDel,
                                    "category"
                                );
                            }
                        }
                    }
                })
                .catch((error) => {
                    this.makeToast(
                        "danger",
                        this.getCommonText("on_del"),
                        error.toString()
                    );
                });
        },

        async loadGoodsData(cat) {
            this.isLoad = true;
            this.templateTableOverlay = true;
            if (!cat.category_id) {
                this.templateTableOverlay = false;
                return;
            }

            const newHeader = { ...this.header, cat_code: cat.category_id };
            try {
                const response = await fetch(
                    "/api-py/get-budget-request-form-goods/",
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json;charset=utf-8",
                        },
                        body: JSON.stringify(newHeader),
                    }
                );

                if (response.status === 200) {
                    const values = await response.json();
                    await this.ensTruDataAddingToGoods(values);
                    values.forEach((val) => {
                        this.$set(val, "isNew", false);
                        this.$set(val, "rowToSave", false);

                        this.$set(
                            val,
                            "currGoodDesc",
                            this.ensTruName.filter(
                                (ens) => ens.code === val.enstru_code
                            )[0]
                        );
                        this.$set(
                            val,
                            "ensTruName",
                            this.ensTruName.filter(
                                (itm) => itm["name_" + this.lang] === val.name
                            )
                        );
                        this.$set(val, "itemToDelete", false);
                        this.$set(val, "isHasDouble", false);
                        this.$set(val, "isDataValid", true);
                    });
                    this.goodsData = values;
                    this.addOrderNumber(this.goodsData);
                }
            } catch (error) {
                this.makeToast(
                    "danger",
                    `${this.getErrText("bad_request")} loadGoodsData()`,
                    error.toString()
                );
            }
            this.templateTableOverlay = false;
            this.isLoad = false;
        }, // загрузка списка расшифровок

        checkForDuplicates(fieldName) {
            const existingItems = {};
            for (const [idx, item] of this.budgetForm.entries()) {
                const curCode = item[fieldName];
                if (existingItems.hasOwnProperty(curCode)) {
                    this.budgetForm[
                        existingItems[curCode]
                    ].checkForDuplicates = true;
                    item.checkForDuplicates = true;
                    this.areDoublesFound = true;
                    break;
                } else {
                    item.checkForDuplicates = false;
                    existingItems[curCode] = idx;
                }
                this.areDoublesFound = false;
            }
        },

        async deleteRows(items, mode) {
            this.isLoad = true;
            const data = {
                item: items,
                header: this.header,
                mode: mode,
                form: this.header.form,
            };
            try {
                const response = await fetch(
                    "/api-py/delete-list-budget-request-form/",
                    {
                        method: "DELETE",
                        headers: {
                            "Content-Type": "application/json;charset=utf-8",
                        },
                        body: JSON.stringify(data),
                    }
                );
                if (response.ok) {
                    const updateOnlyCategory = mode === "caterorty";
                    await this.updateDatas(updateOnlyCategory);
                    this.makeToast(
                        "success",
                        this.getErrText("msg"),
                        this.getErrText("one_deleted")
                    );
                } else {
                    this.makeToast(
                        "danger",
                        this.getErrText("warning"),
                        "Error:" + response.status
                    );
                }
            } catch {
                this.makeToast(
                    "danger",
                    this.getErrText("warning"),
                    this.getErrText("on_del")
                );
            }
            this.isLoad = false;
        }, // удаление данных

        getFiles(data) {
            this.files = data;
        },

        keyPress: function (event, pattern) {
            const regex = new RegExp(pattern);
            const key = String.fromCharCode(
                !event.charCode ? event.which : event.charCode
            );
            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            }
        }, // вводит по заданному паттерну

        async loadCategoryData() {
            this.selectAll = false;
            this.isLoad = true;
            this.budgetForm.splice(0);
            try {
                const response = await fetch(
                    "/api-py/get-budget-request-form-cat/" +
                        JSON.stringify(this.header)
                );
                if (response.ok) {
                    const values = await response.json();
                    this.fillTotalAmountBySpecificity(values);
                    for (const val of values) {
                        const item = { ...val };
                        const curr_product_group = this.dictProductGroups.find(
                            (itm) => itm.code === val.product_group
                        );
                        this.$set(item, "actual_expens", null);
                        this.$set(item, "revis_plan", null);
                        this.$set(
                            item,
                            "curr_product_group",
                            curr_product_group || null
                        );
                        this.$set(item, "newCat", false);
                        this.$set(item, "files", this.getUnicFilesArr(val)),
                            this.$set(item, "checkForDuplicates", false);
                        this.$set(item, "itemToDelete", false),
                            this.budgetForm.push(item);
                    }
                    this.addOrderNumber(this.budgetForm);
                    this.disableSelectedCodes();
                }
            } catch (error) {
                this.makeToast(
                    "danger",
                    `${this.getErrText("bad_request")} loadCategoryData()`,
                    error.toString()
                );
            }
            this.isLoad = false;
        },

        fillTotalAmountBySpecificity(values) {
            this.createTotalAmountBySpecificity();
            const totalAmountRow = this.removeAndReturnItem(values);
            if (totalAmountRow) {
                this.$set(
                    this.totalAmountBySpecificity,
                    "id",
                    totalAmountRow.id
                );
                this.$set(
                    this.totalAmountBySpecificity,
                    "actual_expens",
                    totalAmountRow.actual_expens
                );
                this.$set(
                    this.totalAmountBySpecificity,
                    "revis_plan",
                    totalAmountRow.revis_plan
                );
                this.$set(this.totalAmountBySpecificity, "newCat", false);
            } else {
                this.resetTotalAmountBySpecificity();
            }
        },
        async loadDict() {
            await this.getDictProductGroups();
        },
        resetTotalAmountBySpecificity() {
            this.$set(this.totalAmountBySpecificity, "id", -1);
            this.$set(this.totalAmountBySpecificity, "actual_expens", 0);
            this.$set(this.totalAmountBySpecificity, "revis_plan", 0);
            this.$set(this.totalAmountBySpecificity, "itemToDelete", false);
        },
        removeAndReturnItem(values) {
            const idx = values.findIndex((item) => !item.product_group);
            if (idx !== -1) {
                return values.splice(idx, 1)[0];
            }
            return null;
        },

        prepareForSaveDecodes(event) {
            event.preventDefault();
            if (!this.goodsData.length || !this.variantAttribute) {
                this.makeToast(
                    "warning",
                    this.getErrText("msg"),
                    this.getErrText("not_saved")
                );
            }

            if (this.isDoubleDecodeExist()) {
                this.makeToast(
                    "warning",
                    this.getErrText("not_saved"),
                    this.getErrText("not_valid")
                );
                return;
            }
            if (!this.ifAllFieldsFilled()) return;

            const values = [];
            for (const row of this.goodsData) {
                if (!row.rowToSave) continue;
                values.push(row);
            }

            this.save(values);
        },

        ifAllFieldsFilled() {
            if (this.goodsData.some((item) => item.ensTruPassVal === false)) {
                this.makeToast(
                    "warning",
                    this.getCommonText("attention"),
                    this.getCommonText("not_selected")
                );
                return false;
            }
            if (this.goodsData.some((item) => item.descrPassVal === false)) {
                this.makeToast(
                    "warning",
                    this.getCommonText("attention"),
                    this.getCommonText("descr_not_selected")
                );
                return false;
            }
            if (this.goodsData.some((item) => item.amountPassVal === false)) {
                this.makeToast(
                    "warning",
                    this.getCommonText("attention"),
                    this.getCommonText("amnt_more_zero")
                );
                return false;
            }
            if (this.goodsData.some((item) => item.costPassVal === false)) {
                this.makeToast(
                    "warning",
                    this.getCommonText("attention"),
                    this.getCommonText("unit_cost_more_zero")
                );
                return false;
            }
            return true;
        }, // проверка заполненности полей у расшифровках

        isDoubleDecodeExist() {
            return this.goodsData.some(item => item.isHasDouble === true);
        },

        isAllDataValid() {
            const hasNotValidData = this.goodsData.some(
                (item) => !item.isDataValid
            );
            return !hasNotValidData;
        },

        async getDictProductGroups() {
            try {
                const response = await fetch(
                    `/api-py/get-dict-product-groups/${this.header.variant_date_time}`
                );
                if (response.ok) {
                    const items = await response.json();
                    this.dictProductGroups = items;
                } else {
                    this.makeToast(
                        "danger",
                        `${this.getErrText(
                            "bad_request"
                        )} getDictProductGroups`,
                        `Error code: ${response.status}`
                    );
                }
            } catch (error) {
                this.makeToast(
                    "danger",
                    `${this.getErrText("bad_request")} getDictProductGroups`,
                    error.toString()
                );
            }
        },

        disableProductGroups() {
            this.dictProductGroups.forEach((item) => {
                const isProductGroupSelected = this.budgetForm.some(
                    (bf) => bf.product_group === item.code
                );
                this.$set(item, "$isDisabled", isProductGroupSelected);
            });
        },
    },
    computed: {
        total() {
            let sum = 0;
            for (const row of this.budgetForm) {
                sum += parseFloat(row.total);
            }
            return Math.ceil(sum);
        },

        totalAmount() {
            let sum = 0;
            for (const row of this.budgetForm) {
                sum += parseFloat(row.amount);
            }
            return sum;
        },

        totalOneItemCost() {
            if (this.totalAmount === 0) return 0;
            const totalOneItemCost = (this.total * 1000) / this.totalAmount;
            return this.roundNumber(totalOneItemCost, 2);
        },

        caterogyName() {
            const localNameField =
                this.$i18n.locale === "kk" ? "name_kk" : "name_ru";
            return `${this.currCategory.curr_product_group[localNameField]}`;
        },

        budgetFormWithTotalAmount() {
            return [...this.budgetForm, this.totalAmountBySpecificity];
        },

        getFormText() {
            return this.setFormText("form_01_158.");
        },

        curYearMin2() {
            let curYearMin2 = "____";
            if (this.header && this.header.cur_year) {
                curYearMin2 = (this.header.cur_year - 2).toString();
            }
            return curYearMin2;
        },

        curYearMin1() {
            let curYearMin1 = "____";
            if (this.header && this.header.cur_year) {
                curYearMin1 = (this.header.cur_year - 1).toString();
            }
            return curYearMin1;
        },

        tableFields() {
            if (this.$i18n.locale) {
                return [
                    {
                        key: "selection",
                        label: " ",
                    },
                    {
                        key: "action",
                        label: " ",
                    },
                    {
                        key: "order_number",
                        label: this.getCommonText("sn"),
                    },
                    {
                        key: "product_group",
                        label: this.getFormText("product_group"),
                    },
                    {
                        key: "inf_sys",
                        label: this.getFormText("inf_sys"),
                    },
                    {
                        key: "name_prod",
                        label: this.getFormText("name_prod"),
                    },
                    {
                        key: "actual_expens",
                        label: this.getFormText("actual_expens", {
                            year: this.curYearMin2,
                        }),
                    },
                    {
                        key: "revis_plan",
                        label: this.getFormText("revis_plan", {
                            year: this.curYearMin1,
                        }),
                    },
                    {
                        key: "amount",
                        label: this.getFormText("amount"),
                    },
                    {
                        key: "one_item_cost",
                        label: this.getFormText("one_item_cost"),
                    },
                    {
                        key: "total",
                        label: this.getFormText("total"),
                    },
                    {
                        key: "files",
                        label: this.getCommonText("files"),
                    },
                    {
                        key: "more",
                        label: "",
                    },
                ];
            }
            return [];
        },
    },
};
</script>
<style scoped>
.filter-actions-flex {
    display: flex;
}

.table-plus {
    border: none;
}

.form01-158_product-group {
    width: 300px;
}
</style>
